import { Component, OnInit } from '@angular/core';
import { FlashController } from '../../../flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-card-image-list',
  templateUrl: './card-image-list.component.html',
  styleUrls: ['../way-to-pay.component.sass']
})
export class CardImageListComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
